<template>
    <div class="mb-0.5" id="mainHeader">
        <div :style="headerNavStyle">
            <nav class="navbar  scrolling-navbar double-nav "
                :style="headerNavStyleTwo">
                <div class="container-fluid my-0 landbased-header-typography">
                    <div style="width: 70%;" id="navbarText">
                        <div class="d-flex" style="width:100%">
                            <div v-for="(item, index) in filteredCategories" :key="index" @click="change_view(index)"
                                style="cursor:pointer;display:table; padding: 0 1.2rem;" class="px-3 pe-3 text-center">
                                <span style="display:table-cell;vertical-align:middle;font-weight: 400;"
                                    :style="skin.header_desktop.nav_bar_text + getNavBarStyle(item.url)">{{
                                        translate(item.name) }}</span>
                            </div>
                            <div v-if="skin.customActionButton.enabled" @click="user.token != '' ? action() : login()"
                                style="cursor:pointer;display:table;" class="px-3 pe-3 text-center">
                                <span
                                    :style="skin.header_desktop.nav_bar_text + (actualRoute === '' ? (skin.header_desktop.selection ?? 'color: white !important') : '')"
                                    style="display:table-cell;vertical-align:middle;"><i
                                        class="fa fa-external-link fa-fw"></i></span>
                            </div>
                        </div>
                    </div>
                    <div style="" class="d-flex align-items-center">
                        <div v-if="user.token != ''" class="px-2 pe-2 text-center" style="display:table;">
                            <div v-if="skin.header_desktop.balance" class="nav-item"
                                :class="skin.my_account.myaccount_type == 'JM' ? '' : 'text-end'"
                                style="cursor:pointer;display:flex;vertical-align:middle;font-size: 15px;padding: 0px 30px 0 0px;"
                                :style="skin.header_desktop.nav_bar_text">
                                <i @click="showBalanceAction" class="fas fa-sync-alt pr-0 mx-2 icon-balance"
                                    :class="{ 'icon-balance-refreshing': isBalanceRefreshing }"
                                    :style="skin.header_desktop.selectionTwo">
                                </i>
                                <span >{{ user.user_data.data ? new
                                    Intl.NumberFormat("de-DE", {
                                        minimumFractionDigits:
                                            skin.qBet_config.decimalsQty, maximumFractionDigits:
                                            skin.qBet_config.decimalsQty
                                    }).format(balance.saldo) : 0 }}
                                </span>
                            </div>
                            <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.support"
                                ref="supportWrapperDesktop" class="dropdown nav-item position-relative"
                                style="cursor:pointer;display:table-cell;vertical-align:middle;">
                                <span :style="skin.header_desktop.nav_bar_text + (this.message_recived ? 'color:red;' : '')"
                                    @click.stop="openSupportModalJivo()">
                                    <i class="far fa-comment-dots" :style="skin.header_desktop.support_color"></i>
                                </span>
                                <div v-if="showSupportPanel" class="support-dropdown">
                                    <div class="support-dropdown-title">
                                        &bull; {{ translate('mesa') }} &bull;
                                    </div>
                                    <button type="button" class="support-dropdown-row" @click.stop="openSupportModal('newMessage')">
                                        <span class="support-dropdown-icon">
                                            <i class="fa fa-paper-plane"></i>
                                        </span>
                                        <span class="support-dropdown-text">{{ translate('reportar') }}</span>
                                    </button>
                                    <a class="support-dropdown-row support-dropdown-ticket" v-for="(ticket, index) in supportTickets"
                                        :key="'new-' + index" href="#" @click.prevent.stop="openSupportModal(ticket)">
                                        <span class="support-dropdown-icon">
                                            <i class="fa-regular fa-comment"></i>
                                        </span>
                                        <span class="support-dropdown-text">Ticket #{{ ticket.id }}</span>
                                        <span class="support-dropdown-meta">
                                            {{ countDays(ticket.fecha) }}d
                                            <i class="far fa-clock" aria-hidden="true"></i>
                                        </span>
                                    </a>
                                    <div class="support-dropdown-title support-dropdown-title-bottom">
                                        &bull; {{ translate('notifi') }} &bull;
                                    </div>
                                    <template v-if="false">
                                    <div class="text-center">
                                        <span>• {{ translate('mesa') }} •</span>
                                    </div>
                                    <div class="my-1 mb-1 support-report-row" @click.stop="openSupportModal('newMessage')">
                                        <i class="fa fa-paper-plane mx-2"></i>
                                        <span>{{ translate('reportar') }}</span>
                                    </div>
                                    <div class="my-1 mb-1">
                                        <a class="dropdown-item support-item support-item-read" v-for="(ticket, index) in supportTickets"
                                            :key="index" href="#" @click.prevent.stop="openSupportModal(ticket)">
                                            <span>Ticket #{{ ticket.id }}</span>
                                            <span class="float-end"> {{ countDays(ticket.fecha) }}d <i class="far fa-clock"
                                                    aria-hidden="true"></i></span>
                                        </a>
                                    </div>
                                    <div class="text-center">
                                        <span>• {{ translate('notifi') }} •</span>
                                    </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div v-if="user.token == '' && skin.register" @click="register"
                            style="cursor:pointer;display:table;width: 100%;" :style="skin.header_desktop.register_btn"
                            class="py-2 px-2 pe-2 text-center">
                            <span style="display:table-cell;vertical-align:middle;">{{ translate("sign_in") }}</span>
                        </div>
                        <div v-if="user.token == '' && skin.login" @click="login"
                            style="cursor:pointer;display:table;width: 100%;" :style="skin.header_desktop.login_btn"
                            class="py-2 px-2 pe-2 text-end">
                            <span style="display:table-cell;vertical-align:middle;"><i class="fas fa-sign-in-alt"></i>
                                {{ translate("log_in") }}</span>
                        </div>
                        <div v-if="user.token != ''" style="cursor:pointer;"
                            class="py-1 me-2 pb-1 px-2 pe-2 text-center nav-item dropdown">
                            <a v-if="skin.my_account.myaccount_type == 'JM'" :style="skin.header_desktop.nav_bar_text"
                                class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="far fa-user mx-2"></i>
                                <span class="desktop-user-name">
                                    {{ user.user_data.data ? user.user_data.data.user_name : '' }}
                                </span>
                            </a>
                            <a v-else :style="skin.header_desktop.nav_bar_text" class="nav-link dropdown-toggle" href="#"
                                id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="far fa-user mx-2"></i>{{ user.user_data.data ? user.user_data.data.name : '' }}
                            </a>
                            <div style="color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;inset: 32px 00px auto auto;width: 180px;"
                                class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.changePassword"
                                    id="changePasswordBtn" class="px-2 pe-2 dropdown-item" data-bs-toggle="modal"
                                    data-bs-target="#changePasswordJm">
                                    <span>{{ translate('change_password') }}</span>
                                </div>
                                <div class="px-2 pe-2   dropdown-item" data-bs-toggle="modal" data-bs-target="#languageModal">
                                    <span>Cambiar Idioma</span>
                                </div>
                                <div v-if="skin.my_account.myaccount_type == 'JM'">
                                    <div v-if="skin.header_desktop.userMenu.balanceHistory" @click="getMovements()"
                                        class="px-2 pe-2   dropdown-item" data-bs-toggle="modal" data-bs-target="#myAccountJm">
                                        <span>{{ translate('balance_history') }}</span>
                                    </div>
                                </div>
                                <div v-else class="px-2 pe-2   dropdown-item" data-bs-toggle="modal" data-bs-target="#myAccount">
                                    <span>{{ translate('balance_history') }}</span>
                                </div>
                                <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.loginHistory"
                                    @click="getIngresos()" class="px-2 pe-2   dropdown-item" data-bs-toggle="modal"
                                    data-bs-target="#historial_ingresos"> <span>{{ translate('history_ingre') }}</span>
                                </div>
                                <div class="px-2 pe-2   dropdown-item" data-bs-toggle="modal" data-bs-target="#limitModalJm">
                                    <span>Limites de apuestas</span>
                                </div>
                                <div class="px-2 pe-2   dropdown-item" @click="openContactAgentInfo">
                                    <span>Contactar a mi Agente</span>
                                </div>
                                <div v-if="skin.logout && !this.autologin" @click="logout" class="px-2 pe-2 dropdown-item "> <span>{{ translate('close')
                                }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </nav>
        </div>

        <div>
            <myAccountJM v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
                style="display:none;"></button>
            <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
                style="display:none;"></button>
            <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <register v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <languageJm v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <supportJmModal ref="supportModalDesktop" modal-id="supportJmDesktop" />
            <betLimitsModal />
        </div>
    </div>
</template>

<script>
import myAccountJM from "./my_account.vue";
import login from "./login.vue";
import register from './register.vue';
import languageSelector from './language.vue';
import languageJm from './languageJm.vue';
import supportJmModal from './supportJmModal.vue';
import changePassword from "./changePassword.vue";
import historialIngresos from "./historialIngresos.vue";
import betLimitsModal from "./betLimits.vue";
export default {
    name: "mainHeader8",
    props: {
        skin: Object,
        language: String,
        translation: Object,
        iframeTransparentHeader: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showBalance: false,
            isBalanceRefreshing: false,
            userDataLoaded: false,
            showSupportPanel: false,
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
            newMessage: false,
            supportTickets: [],
        }
    },
    components: {
        myAccountJM,
        login,
        register,
        languageSelector,
        languageJm,
        supportJmModal,
        betLimitsModal,
        changePassword,
        historialIngresos
    },
    methods: {
        openContactAgent() {
            this.$root.$emit('openContactAgent');
        },
        openContactAgentInfo() {
            this.$root.$emit('openContactAgentInfo');
        },
        getNavBarStyle(view) {
            return view === this.$store.state?.infoRouter?.url
                ? (this.$props.skin.header_desktop.selection ?? 'color: white !important')
                : '';
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        showBalanceAction() {
            this.isBalanceRefreshing = false;
            this.$nextTick(() => {
                this.isBalanceRefreshing = true;
                setTimeout(() => {
                    this.isBalanceRefreshing = false;
                }, 650);
            });

            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        openSupportModalJivo() {
            this.showSupportPanel = !this.showSupportPanel;
            if (this.showSupportPanel) {
                this.getSupportTickets();
                this.$store.dispatch("setMessage", false);
            }
        },
        openSupportModal(payload) {
            this.showSupportPanel = false;
            this.$refs.supportModalDesktop?.open(payload);
        },
        async getSupportTickets() {
            this.supportTickets = [];
        },
        handleDocumentClick(event) {
            const wrapper = this.$refs.supportWrapperDesktop;
            if (!wrapper) return;
            if (!wrapper.contains(event.target)) {
                this.showSupportPanel = false;
            }
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        login() {
            document.getElementById('login_btn').click();
        },
        register() {
            document.getElementById('register_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        my_account() {
            window.parent.postMessage(
                {
                    action: 'openSlider',
                    tab: 'recentBets'
                },
                '*'
            );
        },
        change_view(view) {
            this.$store.dispatch("changeView", view);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        }
    },
    computed: {
        autologin() {
            return this.$store.getters["getAutologin"]
        },
        headerNavStyle() {
            const baseStyle = this.$props.skin?.header_desktop?.nav_bar || '';
            if (!this.isHomeCategory) {
                return `${baseStyle};${this.nonHomeHeaderBackground}padding: 8px 16px;`;
            }
            if (!this.iframeTransparentHeader) return baseStyle;
            return `${baseStyle};background: transparent !important;background-color: transparent !important;position: absolute !important;width: 100% !important; 
            border-bottom: 1px solid #455157;
            box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 5px 0px, rgba(0, 0, 0, 0.12) 0px 2px 10px 0px;`;
        },
        headerNavStyleTwo() {
            if (!this.isHomeCategory) return this.nonHomeHeaderBackground;
            return `background: transparent !important;background-color: transparent !important;`;
        },
        isHomeCategory() {
            return ['lobby', 'inicio'].includes(this.currentCategory);
        },
        nonHomeHeaderBackground() {
            return 'background: #21272A !important;background-color: #21272A !important;';
        },
        currentCategory() {
            return this.$store.state?.infoRouter?.category || '';
        },
        filteredCategories() {
            return this.$props.skin.categories.filter(category => category.active);
        },
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        actualRoute() {
            return this.$store.getters["getActualRoute"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
        header_productsQty() {
            let products = [this.$props.skin.poker, this.$props.skin.prematch, this.$props.skin.casinoN, this.$props.skin.casino_live, this.$props.skin.hipicas, this.$props.skin.login, this.$props.skin.logout];
            return products.filter(x => x == true).length + 1;
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
        document.addEventListener('click', this.handleDocumentClick);
        this.$root.$on('openLogin', () => {
            this.login();
        });
    },
    watch: {
        userDataLoaded(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.getSupportTickets();
            }
        },
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleDocumentClick);
        this.$root.$off('openLogin');
    }
}
</script>

<style scoped>
/* @import url("https://cdn.jsdelivr.net/npm/@typehaus/metropolis@12.0.0-next.7/300.css"); */

.landbased-header-typography,
/* .landbased-header-typography span, */
.landbased-header-typography a,
.landbased-header-typography button,
.landbased-header-typography .nav-link,
.landbased-header-typography .dropdown-menu {
    font-family: "Metropolis";
    font-size: 15px ;
    font-weight: 500 ;
}

.landbased-header-typography .dropdown-item {
    font-family: "Metropolis";
    font-weight: 500;
    padding: 8px;
    font-size: 13px;
    color: #fff;
    margin-left: 7px;
}
.dropdown-item:focus, .dropdown-item:hover{
    background-color: #292d3d;
    width: auto;
}

.navbar{
    padding: 0;
}

.center_div {
    width: 90%;
    /* Can be in percentage also. */
    height: auto;
    margin: 0 auto;
    padding: 0px;
    position: relative;
}

.jackpot-btn {
    animation: blink 1.5s infinite ease-in-out;
    transition: all 0.3s ease-in-out;
    font-size: 14px;
    padding: 6px;
    margin-right: 5px;
    font-weight: bold;
    border: none;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 10px;
    text-transform: uppercase;
}

.jackpot-btn:hover {
    animation: none;
}

.recargar-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 10px;
    margin-left: 8px;
    border: 1px solid #c9a227;
    border-radius: 10px;
    background: linear-gradient(45deg, #c9a227, #f2d36b);
    color: #1c1c1c;
    font-weight: 700;
    text-transform: uppercase;
    box-shadow: 0 0 12px rgba(201, 162, 39, 0.45);
    cursor: pointer;
}

.recargar-btn:hover {
    filter: brightness(1.05);
}

.whatsapp-recargar-wrap {
    display: flex;
    align-items: center;
    gap: 3px;
}

#mainHeader .nav-link.dropdown-toggle {
    border-radius: 8px;
    padding: 6px 14px;
    /* background: rgba(0, 0, 0, 0.2); */
}

#mainHeader .dropdown-menu {
    min-width: 190px;
    background-color: rgba(58, 58, 58, 0.94) !important;
    border: 1px solid rgba(255, 255, 255, 0.08);
    left: -40px;
    border-radius: 4px;
}
#mainHeader{
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12);
    font-weight: 300;
}

.support-dropdown {
    position: absolute;
    top: 30px;
    left: auto;
    right: 0;
    width: 20rem;
    color: #fff;
    /* background-color: rgba(60, 60, 60, 0.94); */
    background-color: rgba(60, 60, 60, .9);
    border: #fff;
    border-radius: 6px;
    z-index: 1050;
    font-size: 15px;
    margin-top: 3px;
    padding: 8px;
    font-size: .8rem;
    font-weight: 300;
    font-family: "Metropolis"
}
.support-dropdown-title{
    font-family: "Metropolis";
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: .8rem;
    font-weight: 500;
}

.support-dropdown-row{
    font-family: "Metropolis";
    font-size: 15px;
    background: transparent;
    border: none;
    color: #fff;
    display: flex;
    justify-content: left;
    margin: 14px;
}
.support-dropdown-row:hover{
    background-color: #292d3d;
}
.support-dropdown-icon{
    margin-right: 10px;
    width: 20px;
}
.support-dropdown-text{
    font-size: .8rem;
    font-weight: 500;
}

.support-report-row {
    background: rgba(31, 45, 79, 0.95);
    border-radius: 4px;
    padding: 10px;
    cursor: pointer;
}

.support-modal-content {
    background-color: rgba(52, 52, 52, 0.96) !important;
    border: 0;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: none;
}

.support-modal-header {
    color: #fff;
}

.support-modal-body {
    padding: 24px !important;
    background: #464646;
}

.support-modal-title {
    margin: 0;
}

.support-modal-close {
    background: transparent !important;
    float: right;
    color: white !important;
    opacity: 1;
}

.support-modal-close::before {
    content: none;
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    color: currentColor;
}

.support-message-wrapper {
    display: flex;
    align-items: center;
    gap: 14px;
}

.support-file-btn {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 0;
    color: #fff;
    background: #2a2f4d;
    flex: 0 0 auto;
    margin-top: 0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.28);
}

.support-input,
.support-textarea {
    width: 100%;
    border: 0;
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 14px;
    color: #4f4f4f;
    background: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.support-input {
    height: 40px;
}

.support-textarea {
    min-height: 115px;
    resize: vertical;
    padding-top: 12px;
}

.support-input::placeholder,
.support-textarea::placeholder {
    color: #707070;
}

.support-actions {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 1.6rem !important;
}

.support-btn {
    border: 0;
    border-radius: 2px;
    padding: 12px 26px;
    color: #fff;
    min-width: 105px;
    font-size: 14px;
    font-weight: 500;
}

.support-btn.secondary,
.support-btn.primary {
    background: #292d3d;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.22);
}

@media (max-width: 480px) {
    .support-modal-header {
        padding: 12px 14px;
    }

    .support-modal-body {
        padding: 18px !important;
    }
}
.icon-balance{
    color: lightgreen !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1em;
    height: 1em;
    line-height: 1;
    transition: transform 0.2s ease, color 0.2s ease;
    transform-origin: 50% 50%;
    will-change: transform;
}

.icon-balance-refreshing {
    animation: balance-refresh-spin 0.36s linear;
}

@keyframes balance-refresh-spin {
    0% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@media (max-width: 1199.98px) {
    .desktop-user-name {
        display: none;
    }
}
</style>
